import { useSelector, useDispatch } from "react-redux";
import { logout } from "../store/slices/userSlice.js";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
const Header = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate()
  const user = useSelector((state) => state.user.profile);

  const handleLogout = () => {
    dispatch(logout());
       toast.info("You have been logged out!");

    
        // Show toast notification
   
    setTimeout(() => {
      localStorage.removeItem("auth");
    localStorage.removeItem("token");
      navigate("/");
      // window.location.href = "/";
    }, 10);

 

    
  };

  return (
    <header className="h-16 bg-white border-b flex items-center justify-between px-6">
      {/* Left */}
      <h1 className="text-lg font-semibold text-gray-800">Dashboard Panel</h1>

      {/* Right */}
      <div className="flex items-center gap-4">
        {user && (
          <span className="text-sm text-gray-700">
            Welcome, <span className="font-semibold">{user.name}</span>
          </span>
        )}

        <button
          onClick={handleLogout}
          className="text-sm bg-amber-500 text-white px-4 py-1.5 rounded-md hover:bg-amber-600 transition"
        >
          Logout
        </button>
      </div>
    </header>
  );
};

export default Header;
